import { $, _ } from 'wgnet-awesomejs';

export default function initTooltip(container) {
    const leftDefaultPosition = -26;
    const rightDefaultPosition = 0;
    const mobileResolutionTriggerSize = 500;
    const el = $(container);
    if (el.length === 0) {
        return null;
    }
    const calcLeft = (tooltip) => {
        let right;
        let left;
        const isRtlLang = _.extract('Settings.cssDirection') === 'rtl';
        if ($(window).width() < mobileResolutionTriggerSize) {
            if (isRtlLang) {
                right = (tooltip.offset().left + (2 * tooltip.width())) - window.innerWidth;
            } else {
                left = -tooltip.offset().left;
            }
        } else {
            left = leftDefaultPosition;
            right = rightDefaultPosition;
        }
        return { left, right };
    };
    const closeTooltip = () => {
        if ($('.tooltip-info')) {
            $('.js-tooltip-close').click();
        }
    };
    el.on('click', '.js-tooltip', (event) => {
        const tooltip = $(event.currentTarget);
        const wrapper = $('.js-tooltip-wrapper', tooltip);
        const openClass = tooltip.data('open-class');
        wrapper.css(calcLeft(tooltip));
        tooltip.addClass(openClass);
        return false;
    });
    el.on('click', '.js-tooltip-close', (event) => {
        const tooltip = $(event.currentTarget).parents('.js-tooltip')[0];
        const openClass = tooltip.getAttribute('data-open-class');
        tooltip.classList.remove(openClass);
        event.stopPropagation();
        return false;
    });
    $('body').on('click', ':not(.js-tooltip)', () => {
        closeTooltip();
    });
    $(window).resize(() => {
        closeTooltip();
    });
    $(window).on('orientationchange', () => {
        closeTooltip();
    });
    return el;
}



// WEBPACK FOOTER //
// ./registration/static_source/js/registration/base/tooltip.js